// src/features/system/user/api/usersApi.ts
import { bff } from '@/lib/http/bff';

export interface User {
  id_user: number;
  username: string;
  full_name?: string | null;
  tenant_id?: number | null;
}

export const fetchUsers = (tenantId?: number): Promise<User[]> => {
  return bff.get<User[]>('/users', tenantId != null ? { tenant_id: tenantId } : undefined as any);
};

export interface RegisterUserIn {
  username: string;
  password: string;
  tenant_id: number;
  roles: string[];
}
export interface RegisterUserOut { id_user: number }

export const registerUser = (payload: RegisterUserIn): Promise<RegisterUserOut> =>
  bff.post<RegisterUserOut, RegisterUserIn>('/users/register', payload);
